export default "__VITE_ASSET__B1jRH89k__"